module.exports = __webpack_public_path__ + "static/media/ENS__Logo.f95cb399.svg";